import {Injectable} from '@angular/core';
import {WindowReferenceService} from './window-reference.service';
import {User} from '../user/user';
import {Item, Project} from '../../project/shared/project-model';
import {SessionStorage} from "ngx-webstorage";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})

export class PageViewEventDatalayerService {
  private window;

  @SessionStorage() user: User;
  @SessionStorage() currentProject: Project;
  @SessionStorage() currentItemct: Item;
  @SessionStorage() gaLoginPageTrigger: boolean;

  constructor(private windowRef: WindowReferenceService) {
    this.window = windowRef.nativeWindow;
  }

  private DataLayerTrigger(pageViewEvent) {
    if (pageViewEvent) {
      this.window.dataLayer.push(pageViewEvent);
    }
  }

  PageViewEvent(urlEvent: any, layout?: any) {

    let activeUrl = '';
    if (urlEvent && urlEvent.urlAfterRedirects) {
      activeUrl = urlEvent.urlAfterRedirects;
    } else if (urlEvent === "/news") {
      activeUrl = "/news";
    } else if (urlEvent === "/loadSharedProjects") {
      activeUrl = "/loadSharedProjects";
    } else {
      activeUrl = urlEvent.url;
    }

    let category = "";
    if ((urlEvent.urlAfterRedirects === "/configure" || urlEvent === "/configure") && (layout === true || layout === undefined)) {
      category = "SLD"
    } else if ((urlEvent.urlAfterRedirects === "/configure" || urlEvent === "/configure") && layout === false) {
      category = "LAYOUT";
    } else {
      category = "";
    }

    if (this.user === null || activeUrl?.includes('/admin')) {
      this.gaLoginPageTrigger = true;
      return;
    }

    const mailIdRegex = /\b[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\b/g;
    const removedMailIdString = (this.user.partnerName).replace(mailIdRegex, '');

    let pageTitle = '';
    if (this.currentItemct && activeUrl !== '/projects') {
      pageTitle = this.currentItemct.name;
    }

    let event = {
      event: 'page_view',
      visitor_type: this.user.role,
      user_id: this.user.id,
      user_type: this.user.role,
      user_group: removedMailIdString,
      digital_platform: 'EcoStruxure PowerBuild Contractors',
      digital_platform_country: this.user.partnerCountry,
      product_country: this.user.paceCountry,
      environment: (environment.envType === 'PROD') ? 'production' : 'developement',
      business_unit: 'Energy Management',
      business_divison: 'Power System',
      configurator_id: 46676,
      configurator_name: 'EcoStruxure PowerBuild Contractors',
      page_language: this.user.preferredLanguage,
      page_category: (category !== "" && (urlEvent.urlAfterRedirects === "/configure" || urlEvent === "/configure")) ? "Configuration" : "",
      page_sub_category: category,
      page_sub_sub_category: '',
      page_title: (pageTitle && pageTitle !== '') ? pageTitle : activeUrl.replace('/', ''),
      page_top_category: activeUrl,
      project_name: (this.currentProject && activeUrl !== '/projects') ? this.currentProject.name : '',
      project_id: (this.currentProject && activeUrl !== '/projects') ? this.currentProject.id : '',
      template: (pageTitle && pageTitle !== '') ? pageTitle : activeUrl.replace('/', '')
    };
    this.DataLayerTrigger(event);
  }
}
